module.exports = __webpack_public_path__ + "img/pharmacy.112e9002.png";